export var FIELD_META_PROP = 'data-__meta';


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/form/constants.js
// module id = 447
// module chunks = 0